import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { ViBodyComponent } from '@vi-iot/ui/layouts/body/body.component';
import { ViFooterComponent } from '@vi-iot/ui/layouts/footer/footer.component';
import { ViHeadComponent } from '@vi-iot/ui/layouts/head/head.component';
import { SideNavMode } from '@vi-iot/ui/layouts/sidenav/sidenav.component';
import { Observable } from 'rxjs';

import { ViUIService } from '../../services/ui.service';

@Component({
  selector: 'vi-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatSidenavModule,
    ViHeadComponent,
    ViBodyComponent,
    ViFooterComponent,
  ],
  templateUrl: 'page.component.html',
  styleUrls: ['page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViPageComponent implements AfterViewInit {
  isLoading: Boolean = false;
  position: 'start' | 'end' = 'start';

  sidenavOpened$: Observable<boolean>;

  @Input() footer: Boolean = true;

  @Input() sidenavs: Boolean = true;

  @Input() sidenavMode: SideNavMode = SideNavMode.over;

  @Input() fixedHead: boolean = false;

  @Input() shadowHead: Boolean = true;

  @Input() isWhiteBackground: Boolean = false;

  @Input() desktopMarginLeft: Boolean = false;

  @Input() opened = false;

  @Output() toggleSidenav: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('leftSidenav', { read: MatSidenav })
  leftSidenavRef: MatSidenav;

  @ViewChild('rightSidenav', { read: MatSidenav })
  rightSidenavRef: MatSidenav;

  constructor(private ui: ViUIService, private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.initLoader();
    this.initSidenavs();

    this.leftSidenavRef?._animationEnd.pipe().subscribe(() => {
      this.ui.navPanelData$.next({
        isOpen: this.leftSidenavRef.opened,
        width: this.leftSidenavRef._getWidth(),
      });
    });
  }

  private initLoader(): void {
    this.ui.getLoader$.subscribe((isLoading) => {
      // setTimeout due to:
      // ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked.
      // Previous value: 'undefined'. Current value: 'true'.
      setTimeout(() => {
        this.isLoading = isLoading;
      });
    });
  }

  private initSidenavs(): void {
    if (!this.sidenavs) {
      return;
    }

    this.ui.sidenav$.subscribe(() => {
      this.leftSidenavRef.toggle();
      this.toggleSidenav.emit();
      this.cdr.markForCheck();
    });

    this.ui.sidenavPanel$.subscribe(() => {
      this.rightSidenavRef.toggle();
      this.cdr.markForCheck();
    });

    this.leftSidenavRef._closedStream.subscribe(() => {
      this.ui.sidenavClosed$.next();
      this.cdr.markForCheck();
    });

    this.rightSidenavRef.openedStart.subscribe(() => {
      this.ui.hideBodyScrollbar();
    });

    this.rightSidenavRef.closedStart.subscribe(() => {
      this.ui.unhideBodyScrollbar();
    });

    this.rightSidenavRef._closedStream.subscribe(() => {
      this.ui.panelSidenavClosed$.next();
      this.cdr.markForCheck();
    });
  }
}
